export default function trimErrorKeys(errors: Record<string, string> = {}, trim: string = '') {
    const fieldErrors: Record<string, string> = {};

    Object.entries(errors).forEach(([field, error]) => {
        fieldErrors[field.substring(trim.length)] = error;
    })

    return fieldErrors;
}
